var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStepQuiz = function SvgStepQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.753 6.121 1.061 1.061 2.121-2.121.708.707-2.829 2.828-1.768-1.768.707-.707ZM9 7.775h12v-1H9v1ZM9 12.775h12v-1H9v1ZM21 17.775H9v-1h12v1ZM4.814 12.182l-1.06-1.06-.708.707 1.768 1.768 2.829-2.829-.708-.707-2.12 2.121ZM5.05 18.475a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: "#000"
  })));
};
export default SvgStepQuiz;